import React from "react";
import {colors} from "../../utils/styled/_variables.styled";
import Icon from "../Icon/Icon";
import {InfiosLink} from "./Link.style";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Link = (props) => {
    const { text, className, link, noIcon, inverted, disabled, target, animated, image, children, onMouseEnter, onMouseLeave } = props;

    return (
        <InfiosLink
            data-analytics="link"
            noIcon={noIcon}
            disabled={disabled}
            inverted={inverted}
            className={className}
            href={link}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            target={target || "_self"}>
                {children && <>{children}</>}
                {image && <LazyLoadImage src={image}/>}
                {text}
                {!noIcon && <Icon animated={animated} color={colors.blue} icon="link" />}
        </InfiosLink>
    )
}

export default Link;
